import React from 'react'
import PlayerSubWaitingScreen from '../components/PlayerSubWaitingScreen'

const PlayerWaitingScreen = () => {
  return (
    <>
    <PlayerSubWaitingScreen/>
    </>
  )
}

export default PlayerWaitingScreen